import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const CaptionsEditor = React.lazy(() => import("@kaltura/mediaspace-features-captions-editor"));

export const render = getDsLayoutComponentRenderer(CaptionsEditor);
